import gql from 'graphql-tag';

export const LOADING = gql`
  fragment loading on Loading {
    id
    dateOfLoading
    conditionning
    conditionningQuantity
  }
`;
